module.exports = __webpack_public_path__ + "img/perfil-generico-02.5a016c1a.png";